<script lang="ts">
  import { goto } from '$app/navigation'
  import { resolve } from '$app/paths'
  import { page } from '$app/state'
  import { helpPath, type HelpNode } from '$lib/help'
  import type { Tree } from '$lib/tree'
  import NavTree from './NavTree.svelte'

  interface Props {
    tree: Tree<HelpNode>
  }

  let { tree }: Props = $props()

  const navigate = (e: Event) => {
    goto(resolve(helpPath(`${(e.target as HTMLSelectElement).value}`)))
  }
</script>

<nav>
  <div class="tree">
    <NavTree {tree} />
  </div>
  <select class="@select" value={page.params.slugs} onchange={navigate}>
    {#each tree as post (post.full_slug)}
      <option value={post.full_slug}>
        {post.title}
      </option>
      {#if post.children.length > 0}
        {#each post.children as child (child.full_slug)}
          <option value={child.full_slug}>
            &nbsp;&nbsp;{child.title}
          </option>
        {/each}
      {/if}
    {/each}
  </select>
</nav>

<style lang="postcss">
  @container (height < 5rem) {
    nav {
      padding-right: 0;
    }
    .tree {
      display: none;
    }
    select {
      display: block;
      max-width: none;
    }
  }
  @container (height >= 5rem) {
    nav {
      padding-right: 1rem;
    }
    select {
      display: none;
    }
  }
</style>
